module.exports = __webpack_public_path__ + "static/media/banner-mobile.7dd3afde.png";